<div class="min-price theme-headerBlockBeatPage__beatPrice">
  <p class="min-price__text">{{ lg.button.priceFrom }}</p>
  <p class="min-price__price">{{ minPrice }}</p>
  <p class="min-price__sign">{{ currencySign }}</p>
</div>
